export * from './property-number.component';
